import { render } from "./no-encontrado.vue?vue&type=template&id=03d9da8d"
import script from "./no-encontrado.vue?vue&type=script&lang=js"
export * from "./no-encontrado.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__